import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { InteractionEnum, InteractionValueEnum } from "@/types";
import { useMortgage, useTestId, useCustomerAction, useTrackingProductClick, useIsTablet, } from "@/hooks";
import { PARTNER_NAME, FINANCIAL_LINK_PARTNER, } from "@/shared/types";
import { DsaElement } from "@/components";
import { Box } from "@gemini/core";
import { useBrandContext } from "@/shared/contexts";
import { useClassified, useHardFacts } from "@/contexts/classified";
import { ArrowRightIcon } from "@gemini/icons";
import { Link } from "@gemini/ui";
import { useConfig } from "@/contexts/cdpConfig";
export const MortgagePriceLink = () => {
    var _a, _b, _c, _d, _e;
    const mortgage = useMortgage();
    const { customerActionLeadInteraction } = useCustomerAction();
    const isPreviewMode = useConfig().previewMode;
    const { financialLink } = ((_a = useHardFacts()) === null || _a === void 0 ? void 0 : _a.price) || {};
    const partnerName = PARTNER_NAME.SCHUFA;
    const isTablet = useIsTablet();
    const partner = ((_c = (_b = useBrandContext()) === null || _b === void 0 ? void 0 : _b.partnerService) !== null && _c !== void 0 ? _c : []).find((service) => service.name === partnerName);
    const handleTrackingProductClick = useTrackingProductClick(partnerName);
    const partnerAd = (_e = (_d = useClassified()) === null || _d === void 0 ? void 0 : _d.sections) === null || _e === void 0 ? void 0 : _e.partnerAd;
    const testid = useTestId("Sections.Hardfacts.Price.FinancialLink");
    const priceLabel = mortgage === null || mortgage === void 0 ? void 0 : mortgage.priceLinkLabel;
    if (!priceLabel)
        return null;
    const isBuyPrice = mortgage === null || mortgage === void 0 ? void 0 : mortgage.showMonthlyRateLabel;
    const isRentPrice = !isBuyPrice && (mortgage === null || mortgage === void 0 ? void 0 : mortgage.showRentLabel);
    if (isRentPrice && (!partner || !(partnerAd === null || partnerAd === void 0 ? void 0 : partnerAd.showPartnerAd)))
        return null;
    const handleLinkClick = async () => {
        if (isPreviewMode)
            return;
        if (isBuyPrice)
            handlePartnerLinkClickBuy();
        if (isRentPrice)
            handlePartnerLinkClickRent();
    };
    const addDeviceTracking = (partnerName) => {
        if (partnerName !== FINANCIAL_LINK_PARTNER.CA)
            return "";
        return isTablet ? "&at_libre=Mobile" : "&at_libre=Desktop";
    };
    const handlePartnerLinkClickBuy = async () => {
        window.open(`${financialLink === null || financialLink === void 0 ? void 0 : financialLink.href}${addDeviceTracking(financialLink === null || financialLink === void 0 ? void 0 : financialLink.partnerName)}`, "_blank");
        customerActionLeadInteraction(InteractionEnum.CLICK, InteractionValueEnum.FINANCING);
    };
    const handlePartnerLinkClickRent = async () => {
        if (!(partnerAd === null || partnerAd === void 0 ? void 0 : partnerAd.showPartnerAd))
            return null;
        handleTrackingProductClick();
        await customerActionLeadInteraction(InteractionEnum.CLICK, InteractionValueEnum.SCHUFA);
        window.open(partner.url, "_blank");
    };
    return (_jsxs(Box, { as: "span", display: "flex", alignItems: "center", marginTop: "spacing.8", children: [_jsx(Link, { href: "#" + priceLabel, testId: testid, onPress: handleLinkClick, isDisabled: isPreviewMode, marginRight: "spacing.16", children: priceLabel }), (isRentPrice ||
                (financialLink === null || financialLink === void 0 ? void 0 : financialLink.partnerName) !== FINANCIAL_LINK_PARTNER.KFW) && (_jsxs(_Fragment, { children: [_jsx(ArrowRightIcon, {}), _jsx(DsaElement, {})] }))] }));
};
